export const ChipSx = (elevated?: boolean) => ({
  borderRadius: '6px',
  padding: '5px 0',
  height: 'initial',
  fontSize: '12px',
  color: 'customColors.gray.950',
  backgroundColor: 'customColors.blue.50',
  boxShadow: elevated
    ? '0px 1px 2px 0px rgba(0,0,0,0.04), 0px 0px 1px 0px rgba(0,0,0,0.04)'
    : 'none',

  '&.Mui-disabled': {
    color: 'customColors.gray.400',
    backgroundColor: 'customColors.gray.100',
    borderColor: 'customColors.gray.200',
    opacity: 1,

    '.MuiChip-deleteIcon': {
      color: 'customColors.gray.300',
    },
  },

  '&.large': {
    fontSize: '14px',
    padding: '10px 6px',
    fontWeight: 500,
    letterSpacing: 0,
  },

  '&.MuiChip-outlined': {
    borderColor: 'customColors.gray.200',
    borderWidth: '1px',
    padding: '3.5px 0',

    '.MuiChip-label': {
      padding: '0 8.5px',
      lineHeight: '17px',
    },
  },

  '.MuiChip-label': {
    padding: '0 10px',
    lineHeight: '17px',
  },

  '.MuiChip-deleteIcon': {
    width: '20px',
    height: '20px',
  },

  '&.MuiChip-deletable': {
    svg: {
      margin: '0 8px 0 4px',
    },

    '.MuiChip-label': {
      paddingRight: 0,
      letterSpacing: 0,
    },
  },

  '&.active': {
    backgroundColor: 'customColors.blue.100',
  },
});

export const ChipErrorBadgeSx = {
  display: 'inline-block',
  marginLeft: '4px',
  backgroundColor: '#c61616',
  minWidth: '5px',
  height: '5px',
  borderRadius: '50%',
  verticalAlign: 'top',
};
